<div class="premium-modal-wrapper">
  <ion-header class="ion-no-border premium-header">
    <div class="header-curve"></div>
    <div class="custom-toolbar">
      <div class="toolbar-content">
        <div class="icon-btn" (click)="close()">
          <ion-icon name="chevron-back-outline"></ion-icon>
        </div>
        <div class="title-group">
          <div class="title-main">{{ mode === 'add' ? 'Nueva' : 'Editar' }} Cotización</div>
          <div class="title-sub">Gestión de presupuesto paso a paso</div>
        </div>
      </div>
    </div>
  </ion-header>

  <ion-content class="premium-content-bg modal-content" [scrollY]="true">
    <div class="layout-wrapper">
      <div class="steps-container">
        <div class="step-indicator" [class.active]="currentStep >= 1">1</div>
        <div class="step-line" [class.active]="currentStep >= 2"></div>
        <div class="step-indicator" [class.active]="currentStep >= 2">2</div>
        <div class="step-line" [class.active]="currentStep >= 3"></div>
        <div class="step-indicator" [class.active]="currentStep >= 3">3</div>
      </div>

      <div class="slides-container">

        <!-- STEP 1: Info -->
        <div class="slide-section" *ngIf="currentStep === 1">
          <div class="slide-header">
            <h3>Datos Generales</h3>
            <p>Información básica del solicitante y cliente</p>
          </div>

          <div class="form-card animate__animated animate__fadeIn">
            <!-- SOLICITANTE -->
            <div class="input-group full">
              <label>
                <ion-icon name="people-outline"></ion-icon>
                Solicitante <span class="req" *ngIf="!trabajo">*</span>
              </label>
              <div class="autocomplete-wrapper" [class.disabled-ac]="!!trabajo">
                <div class="premium-input-wrapper" [class.readonly-row]="!!trabajo">
                  <input type="text" [(ngModel)]="formData.solicitante" (input)="filterSolicitantes($event)"
                    (focus)="filterSolicitantes($event)" (blur)="hideDropdown('solicitante')" [disabled]="!!trabajo"
                    placeholder="Buscar solicitante...">
                  <ion-icon name="close-circle" class="ac-clear" *ngIf="formData.solicitante && !trabajo"
                    (click)="clearSolicitante()"></ion-icon>
                  <ion-icon name="lock-closed-outline" class="lock-icon" *ngIf="!!trabajo"
                    style="margin-left: 8px; color: #94a3b8;"></ion-icon>
                </div>
                <div class="ac-dropdown" *ngIf="showSolicitanteDropdown && !trabajo">
                  <div class="ac-item" *ngFor="let s of filteredSolicitantes" (click)="selectSolicitante(s)">
                    <ion-icon name="person-outline"></ion-icon>
                    {{ s.nombre }}
                  </div>
                  <div class="ac-item ac-create" *ngIf="formData.solicitante && !doesSolicitanteExist(formData.solicitante)" (click)="createSolicitante()">
                    <ion-icon name="add-circle-outline"></ion-icon>
                    Crear "{{ formData.solicitante }}"
                  </div>
                </div>
              </div>
              <div class="error-hint"
                *ngIf="formData.solicitante && !selectedSolicitanteId && !showSolicitanteDropdown && !trabajo">
                <ion-icon name="alert-circle-outline"></ion-icon>
                <span>Este solicitante no existe, debes crearlo.</span>
              </div>
              <div class="selected-chip" *ngIf="selectedSolicitanteId && !showSolicitanteDropdown">
                <ion-icon name="checkmark-circle"></ion-icon>
                {{ formData.solicitante }}
              </div>
            </div>

            <!-- CLIENTE -->
            <div class="input-group full">
              <label>
                <ion-icon name="person-outline"></ion-icon>
                Cliente <span class="req" *ngIf="!trabajo">*</span>
              </label>
              <div class="autocomplete-wrapper" [class.disabled-ac]="!!trabajo">
                <div class="premium-input-wrapper" [class.readonly-row]="!!trabajo">
                  <input type="text" [(ngModel)]="formData.cliente" (input)="filterClientes($event)"
                    (focus)="filterClientes($event)" (blur)="hideDropdown('cliente')" [disabled]="!!trabajo"
                    placeholder="Escribe para buscar...">
                  <ion-icon name="close-circle" class="ac-clear" *ngIf="formData.cliente && !trabajo"
                    (click)="clearCliente()"></ion-icon>
                  <ion-icon name="lock-closed-outline" class="lock-icon" *ngIf="!!trabajo"
                    style="margin-left: 8px; color: #94a3b8;"></ion-icon>
                </div>
                <div class="ac-dropdown" *ngIf="showClienteDropdown && !trabajo">
                  <div class="ac-item" *ngFor="let c of filteredClientes" (click)="selectCliente(c)">
                    <ion-icon name="person-circle-outline"></ion-icon>
                    {{ c.nombre }}
                  </div>
                  <div class="ac-item ac-create" *ngIf="formData.cliente && !doesClienteExist(formData.cliente)" (click)="createCliente()">
                    <ion-icon name="add-circle-outline"></ion-icon>
                    Crear "{{ formData.cliente }}"
                  </div>
                </div>
              </div>
              <div class="error-hint"
                *ngIf="formData.cliente && !selectedClienteId && !showClienteDropdown && !trabajo">
                <ion-icon name="alert-circle-outline"></ion-icon>
                <span>Este cliente no existe, debes crearlo.</span>
              </div>
              <div class="selected-chip" *ngIf="selectedClienteId && !showClienteDropdown">
                <ion-icon name="checkmark-circle"></ion-icon>
                {{ formData.cliente }}
              </div>
            </div>

            <!-- DIRECCIÓN -->
            <div class="input-group full">
              <label>
                <ion-icon name="location-outline"></ion-icon>
                Dirección <span class="req" *ngIf="!trabajo">*</span>
              </label>
              <div class="autocomplete-wrapper" [class.disabled-ac]="!selectedClienteId || !!trabajo">
                <div class="premium-input-wrapper" [class.readonly-row]="!!trabajo">
                  <input type="text" [(ngModel)]="formData.direccion" (input)="filterDirecciones($event)"
                    (focus)="filterDirecciones($event)" (blur)="hideDropdown('direccion')"
                    [disabled]="!selectedClienteId || !!trabajo" placeholder="Buscar dirección...">
                  <ion-icon name="close-circle" class="ac-clear" *ngIf="formData.direccion && !trabajo"
                    (click)="clearDireccion()"></ion-icon>
                  <ion-icon name="lock-closed-outline" class="lock-icon" *ngIf="!!trabajo"
                    style="margin-left: 8px; color: #94a3b8;"></ion-icon>
                </div>
                <div class="ac-dropdown" *ngIf="showDireccionDropdown && !trabajo">
                  <div class="ac-item" *ngFor="let d of filteredDirecciones" (click)="selectDireccion(d)">
                    <ion-icon name="location-outline"></ion-icon>
                    {{ d.nombre }}
                  </div>
                  <div class="ac-item ac-create" *ngIf="formData.direccion && !doesDireccionExist(formData.direccion)" (click)="createDireccion()">
                    <ion-icon name="add-circle-outline"></ion-icon>
                    Agregar nueva dirección
                  </div>
                </div>
              </div>
              <div class="error-hint"
                *ngIf="formData.direccion && !selectedDireccionId && !showDireccionDropdown && !trabajo">
                <ion-icon name="alert-circle-outline"></ion-icon>
                <span>Esta dirección no existe, debes crearla.</span>
              </div>
              <div class="selected-chip" *ngIf="selectedDireccionId && !showDireccionDropdown">
                <ion-icon name="checkmark-circle"></ion-icon>
                {{ formData.direccion }}
              </div>
            </div>

            <!-- FECHA -->
            <div class="input-group full">
              <label>
                <ion-icon name="calendar-outline"></ion-icon>
                Fecha de Cotización <span class="req">*</span>
              </label>
              <div class="premium-input-wrapper date-input">
                <input type="date" [(ngModel)]="formData.fechaCot" #dateInputCot>
                <ion-icon name="calendar-outline" class="date-icon" (click)="dateInputCot.showPicker()"></ion-icon>
              </div>
            </div>
          </div>
        </div>

        <!-- STEP 2: Items -->
        <div class="slide-section flex-slide" *ngIf="currentStep === 2">
          <div class="slide-header">
            <h3>Items de Cotización</h3>
            <p *ngIf="!trabajo">Agrega los conceptos a cotizar</p>
            <p *ngIf="trabajo">Items cargados desde el Trabajo #{{trabajo.id}}</p>
          </div>

          <div class="form-card animate__animated animate__fadeIn">
            <div class="grid-inputs">
              <!-- CANTIDAD -->
              <div class="input-group">
                <label>
                  <ion-icon name="calculator-outline"></ion-icon>
                  Cantidad
                </label>
                <div class="premium-input-wrapper">
                  <input type="number" [(ngModel)]="currentItem.cantidad" (ngModelChange)="calculateItemTotal()"
                    placeholder="0">
                </div>
              </div>

              <!-- UNIDAD -->
              <div class="input-group">
                <label>
                  <ion-icon name="construct-outline"></ion-icon>
                  Unidad
                </label>
                <div class="autocomplete-wrapper">
                  <div class="premium-input-wrapper select-preview" (click)="toggleUnidadDropdown()"
                    [class.active-dropdown]="showUnidadDropdown">
                    <div class="selected-value">{{ getUnidadLabel(currentItem.unidad) }}</div>
                    <ion-icon name="chevron-down-outline" class="ac-dropdown-icon"></ion-icon>
                  </div>
                  <div class="ac-dropdown" *ngIf="showUnidadDropdown" style="display: block;">
                    <div class="ac-item" *ngFor="let opt of tipoUnidadOptions" (click)="selectUnidad(opt.value)">
                      <ion-icon name="construct-outline"></ion-icon>
                      {{ opt.label }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="grid-inputs">
              <!-- PRECIO UNITARIO -->
              <div class="input-group">
                <label>
                  <ion-icon name="cash-outline"></ion-icon>
                  Precio Unitario ($)
                </label>
                <div class="premium-input-wrapper">
                  <input type="number" [(ngModel)]="currentItem.preUni" (ngModelChange)="calculateItemTotal()"
                    placeholder="0.00">
                </div>
              </div>

              <!-- AJUSTE DE PRECIO -->
              <div class="input-group" *ngIf="currentItem.preUni > 0">
                <label>Ajustar Precio</label>
                <div class="premium-input-wrapper adjust-wrapper">
                  <input type="number" [(ngModel)]="ajustePrecio" placeholder="0.00" class="adjust-input">
                  <button type="button" class="adjust-btn add" (click)="aplicarAjuste('sumar')" title="Sumar al precio unitario">
                    <ion-icon name="add-outline"></ion-icon>
                  </button>
                  <button type="button" class="adjust-btn sub" (click)="aplicarAjuste('restar')" title="Restar al precio unitario">
                    <ion-icon name="remove-outline"></ion-icon>
                  </button>
                </div>
              </div>
            </div>

            <!-- DESCRIPCION -->
            <div class="input-group full">
              <div class="label-row">
                <label>
                  <ion-icon name="document-text-outline"></ion-icon>
                  Descripción del Item
                </label>
                <ion-button size="small" fill="clear" class="ai-button" (click)="mejorarDescripcionConIA()" [disabled]="isImprovingDesc">
                  <ion-icon name="sparkles-outline" slot="start" *ngIf="!isImprovingDesc"></ion-icon>
                  <ion-spinner name="crescent" *ngIf="isImprovingDesc" slot="start"></ion-spinner>
                  {{ isImprovingDesc ? aiAttemptStatus : 'Mejorar con IA' }}
                </ion-button>
              </div>
              <div class="premium-input-wrapper">
                <textarea [(ngModel)]="currentItem.descripcion" placeholder="Ej: Materiales de pintura" rows="5"
                  class="custom-textarea"></textarea>
              </div>
              
              <!-- Alternador de versión IA vs Original -->
              <div class="ai-toggle-container" *ngIf="selectedDescMode">
                <div class="ai-toggle-row">
                  <button type="button" class="ai-toggle-btn" [class.active]="selectedDescMode === 'original'" (click)="toggleDescMode('original')">
                    Ver versión original
                  </button>
                  <button type="button" class="ai-toggle-btn" [class.active]="selectedDescMode === 'ai'" (click)="toggleDescMode('ai')">
                    Ver versión IA
                  </button>
                </div>
              </div>
            </div>

            <div class="buttons-row align-end" style="margin-top: 10px;">
              <ion-button expand="block" fill="solid" (click)="addItem()" class="premium-fab"
                style="width: 100%; margin: 0;">
                <ion-icon [name]="isEditingItem ? 'create-outline' : 'add-circle-outline'" slot="start"></ion-icon>
                <span>{{ isEditingItem ? 'Modificar Item' : 'Agregar Item' }}</span>
              </ion-button>
            </div>
          </div>

          <div class="items-list" *ngIf="items.length > 0">
            <div class="items-header">Items Agregados ({{items.length}})</div>
            <div class="item-chip" *ngFor="let item of items; let i = index">
              <div class="item-info">
                <span class="item-qty">{{item.cantidad}} {{item.unidad}}</span>
                <span class="item-desc">{{item.descripcion}}</span>
                <span class="item-price">${{item.precio | number:'1.2-2'}}</span>
              </div>
              <div class="item-actions">
                <ion-icon name="information-circle-outline" color="secondary" (click)="viewItemDetail(item)"
                  *ngIf="item.areaId"></ion-icon>
                <ion-icon name="create-outline" color="primary" (click)="editItem(i)"></ion-icon>
                <ion-icon name="trash-outline" color="danger" (click)="removeItem(i)"></ion-icon>
              </div>
            </div>
          </div>
        </div>

        <!-- STEP 3: Summary -->
        <div class="slide-section" *ngIf="currentStep === 3">
          <div class="slide-header centered-header">
            <h3>Resumen Final</h3>
            <p>Verifica los montos y agrega observaciones</p>
          </div>

          <div class="form-card animate__animated animate__fadeIn">
            <!-- OPCIONES RÁPIDAS (MATERIALES/PINTURA) -->
            <div class="quick-toggles-grid">
              <div class="premium-option-chip">
                <ion-icon name="hammer-outline"></ion-icon>
                <span>Herramientas y materiales</span>
                <ion-toggle [(ngModel)]="formData.materiales" [disabled]="!!trabajo"></ion-toggle>
              </div>
              <div class="premium-option-chip">
                <ion-icon name="brush-outline"></ion-icon>
                <span>Pintura de primera calidad</span>
                <ion-toggle [(ngModel)]="formData.ppc"></ion-toggle>
              </div>
            </div>

            <!-- BLOQUE DE MONTOS -->
            <div class="summary-premium-group">
              <div class="summary-row">
                <span class="label">Subtotal:</span>
                <span class="value">${{calcSubtotal | number:'1.2-2'}}</span>
              </div>

              <div class="summary-row toggle-row">
                <div class="label-with-icon">
                  <ion-icon name="receipt-outline"></ion-icon>
                  <span>Aplicar ITBMS (7%)</span>
                </div>
                <ion-toggle [(ngModel)]="formData.applyItbms" (ionChange)="calculateTotals()"></ion-toggle>
              </div>

              <div class="summary-row" *ngIf="formData.applyItbms">
                <span class="label">ITBMS:</span>
                <span class="value">${{calcItbms | number:'1.2-2'}}</span>
              </div>
            </div>

            <!-- TOTAL DESTACADO (FUERA DEL GRUPO PARA ÉNFASIS) -->
            <div class="grand-total-container">
              <span class="total-label">Total:</span>
              <span class="total-value">${{calcTotal | number:'1.2-2'}}</span>
            </div>

            <!-- OBSERVACIONES -->
            <div class="observations-section">
              <label class="section-label">
                <ion-icon name="chatbubble-ellipses-outline"></ion-icon>
                Observaciones
              </label>

              <div class="template-selector" *ngIf="observationTemplates.length > 0">
                <div class="template-chips-scroll">
                  <ion-chip class="template-chip clear-chip" *ngIf="formData.observacion"
                    (click)="applyTemplate('clear')">
                    <ion-icon name="trash-outline"></ion-icon>
                    <ion-label>Limpiar</ion-label>
                  </ion-chip>
                  <ion-chip class="template-chip"
                    [class.active-template]="isTemplateActive(t.texto)"
                    *ngFor="let t of observationTemplates" (click)="applyTemplate(t)">
                    <ion-label>{{t.titulo}}</ion-label>
                  </ion-chip>
                </div>
              </div>

              <div class="premium-input-wrapper">
                <textarea class="custom-textarea" [(ngModel)]="formData.observacion" rows="3"
                  placeholder="Notas adicionales..."></textarea>
              </div>
            </div>
          </div>

          <!-- PPT Section (Premium Chip Style) -->
          <div class="ppt-premium-container">
            <div class="ppt-main-chip" [class.ppt-active]="formData.pptEnabled">
              <ion-icon name="wallet-outline"></ion-icon>
              <span class="ppt-title">PPT</span>
              <ion-toggle [(ngModel)]="formData.pptEnabled" (ionChange)="onPptEnabledChange()"></ion-toggle>
            </div>

            <div class="ppt-content-card animate__animated animate__fadeIn" *ngIf="formData.pptEnabled">
              <div class="input-group full">
                <label><ion-icon name="person-outline"></ion-icon> Solicitante PPT</label>
                <div class="autocomplete-wrapper">
                  <div class="premium-input-wrapper">
                    <input type="text" placeholder="Buscar solicitante..." [value]="formData.pptSolicitanteNombre"
                      (input)="filterPptSolicitantes($event)">
                    <ion-icon name="close-circle" class="ac-clear" *ngIf="formData.pptSolicitanteNombre"
                      (click)="clearPptSolicitante()"></ion-icon>
                  </div>
                  <div class="ac-dropdown" *ngIf="filteredPptSolicitantes.length > 0">
                    <div class="ac-item" *ngFor="let s of filteredPptSolicitantes" (click)="selectPptSolicitante(s)">
                      <ion-icon name="person-circle-outline"></ion-icon>
                      {{s.nombre}}
                    </div>
                  </div>
                </div>
              </div>

              <div class="input-group full">
                <label><ion-icon name="cash-outline"></ion-icon> Monto PPT ($)</label>
                <div class="premium-input-wrapper">
                  <input type="number" [(ngModel)]="formData.pptMonto" (input)="calculateTotals()" placeholder="0.00">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ion-content>

  <div class="form-footer-actions">
    <ion-button (click)="prevStep()" [disabled]="currentStep === 1" fill="outline" class="cancel-modal-btn">
      <ion-icon name="arrow-back-outline" slot="start"></ion-icon>
      Atras
    </ion-button>

    <ion-button (click)="nextStep()" *ngIf="currentStep < 3" class="save-btn">
      Siguiente
      <ion-icon name="arrow-forward-outline" slot="end"></ion-icon>
    </ion-button>

    <ion-button (click)="save()" *ngIf="currentStep === 3" class="save-btn" [disabled]="isSaving">
      Guardar
      <ion-icon name="checkmark-outline" slot="end" *ngIf="!isSaving"></ion-icon>
      <ion-spinner name="crescent" color="light" *ngIf="isSaving" slot="end"></ion-spinner>
    </ion-button>
  </div>
</div>